import { createContext } from 'react';
import { ComponentSettings } from '../types';
import { defaultSettings } from '../settings';

export const ConfigContext = createContext<ComponentSettings>(defaultSettings);
